// import jQuery from "jquery";

class LoginAccountWooCommerce {
    constructor() {
        let register =  jQuery("#customer_login .col-2")
        this.events()
        this.initialise()
    }

    events() {
        jQuery("#button_register").on("click", this.toRegister)
    }

    //initialize
    initialise(){
        jQuery("#customer_login .col-2").addClass("hidden")
    }
    // methods
    toRegister(){
        console.log("register")
        jQuery("#customer_login .col-2").removeClass("hidden")
        jQuery(".create").addClass("hidden")
        jQuery("#customer_login .col-1").addClass("hidden")
    }

}

export default LoginAccountWooCommerce
